// extracted by mini-css-extract-plugin
module.exports = {"dots-wrapper":"VerticalDots_dots-wrapper__keBos","dot":"VerticalDots_dot__QO7pU","animation":"VerticalDots_animation__9gHIG"};